(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compare-bundles-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const send = (name, el) => {
      const handle = el.dataset.cbqOpen || el.dataset.cbqCompare;
      const card = handle && document.querySelector(`[data-cb-card][data-cb-handle="${CSS.escape(handle)}"]`);

      if (card) {
        document.dispatchEvent(new CustomEvent(name, { detail: { handle } }));
      } else if (el.dataset.cbqUrl) {
        window.location.href = el.dataset.cbqUrl;
      }
    };

    const init = (root) => {
      if (root.dataset.cbqReady) return;
      root.dataset.cbqReady = 'true';

      const state = {};
      const usesQ2 = root.dataset.q2 === 'true';
      const results = [...root.querySelectorAll('[data-cbq-result]')];
      const placeholder = root.querySelector('[data-cbq-placeholder]');
      const box = root.querySelector('[data-cbq-result-box]');

      const update = () => {
        let match = null;

        if (state.use) {
          const forUse = results.filter((r) => r.dataset.use === state.use);

          if (!usesQ2) {
            match = forUse.find((r) => r.dataset.amount === 'any') || forUse[0] || null;
          } else {
            const needsAmount = forUse.some((r) => r.dataset.amount !== 'any');
            if (state.amount) match = forUse.find((r) => r.dataset.amount === state.amount);
            if (!match && (state.amount || !needsAmount)) match = forUse.find((r) => r.dataset.amount === 'any');
          }
        }

        results.forEach((r) => {
          r.hidden = r !== match;
        });

        if (placeholder) placeholder.hidden = !!match;
        if (box) box.classList.toggle('has-result', !!match);
      };

      root.addEventListener('click', (event) => {
        const answer = event.target.closest('[data-cbq-q]');
        if (answer) {
          const question = answer.dataset.cbqQ;
          state[question] = answer.dataset.cbqValue;

          root.querySelectorAll(`[data-cbq-q="${question}"]`).forEach((btn) => {
            const active = btn === answer;
            btn.setAttribute('aria-pressed', active ? 'true' : 'false');
            btn.classList.remove(btn.dataset.scheme, btn.dataset.activeScheme);
            btn.classList.add(active ? btn.dataset.activeScheme : btn.dataset.scheme);
          });

          update();
          return;
        }

        const opener = event.target.closest('[data-cbq-open]');
        if (opener && event.target.closest('button, a')) {
          event.preventDefault();
          send('cb:open', opener);
          return;
        }

        const compare = event.target.closest('[data-cbq-compare]');
        if (compare) {
          event.preventDefault();
          send('cb:compare', compare);
        }
      });
    };

    document.querySelectorAll('[data-cbq]').forEach(init);

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-cbq]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-bundles"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const lockScroll = (lock) => {
      document.documentElement.style.overflow = lock ? 'hidden' : '';
    };

    const variantsOf = (card) => [...card.querySelectorAll('[data-cb-variant]')];

    const findVariant = (card, material, colour) =>
      variantsOf(card).find((v) => v.dataset.material === material && v.dataset.colour === colour);

    const pick = (list) => list.find((v) => v.dataset.available === 'true') || list[0];

    const updateGrid = (root, card, variant) => {
      const items = (variant.dataset.cbItems || '').split(';;').filter(Boolean);

      root.querySelectorAll(`[data-cb-cell][data-cb-tier="${card.dataset.cbTier}"]`).forEach((cell) => {
        cell.dataset.included = items.includes(cell.dataset.cbCell) ? 'true' : 'false';
      });
    };

    const applyVariant = (root, card, variant) => {
      const id = variant.dataset.cbVariant;
      const material = variant.dataset.material;
      const colour = variant.dataset.colour;

      card.dataset.material = material;
      card.dataset.colour = colour;

      card.querySelectorAll('[data-cb-for]').forEach((el) => {
        el.hidden = el.dataset.cbFor !== id;
      });

      card.querySelectorAll('[data-cb-material-btn]').forEach((btn) => {
        btn.setAttribute('aria-pressed', btn.dataset.cbMaterialBtn === material ? 'true' : 'false');
      });

      let colourName = '';

      card.querySelectorAll('[data-cb-colour-btn]').forEach((btn) => {
        const key = btn.dataset.cbColourBtn;
        const match = findVariant(card, material, key);
        const selected = key === colour;

        btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
        btn.classList.toggle('is-unavailable', !match);
        btn.classList.toggle('is-sold-out', !!match && match.dataset.available !== 'true');
        if (selected) colourName = btn.dataset.name;
      });

      const materialBtn = card.querySelector(`[data-cb-material-btn="${material}"]`);

      card.querySelectorAll('[data-cb-material-name]').forEach((el) => {
        if (materialBtn) el.textContent = materialBtn.textContent.trim();
      });

      card.querySelectorAll('[data-cb-colour-name]').forEach((el) => {
        el.textContent = colourName;
      });

      updateGrid(root, card, variant);
    };

    const selectMaterial = (root, card, material) => {
      const variant =
        findVariant(card, material, card.dataset.colour) ||
        pick(variantsOf(card).filter((v) => v.dataset.material === material));

      if (variant) applyVariant(root, card, variant);
    };

    const selectColour = (root, card, colour) => {
      const variant =
        findVariant(card, card.dataset.material, colour) ||
        pick(variantsOf(card).filter((v) => v.dataset.colour === colour));

      if (variant) applyVariant(root, card, variant);
    };

    const setCategory = (root, key, scroll) => {
      const panel = root.querySelector(`[data-cb-panel][data-cb-key="${CSS.escape(key)}"]`);
      if (!panel) return null;

      root.querySelectorAll('[data-cb-cat]').forEach((b) => {
        const active = b.dataset.cbKey === key;
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
        b.classList.remove(b.dataset.scheme, b.dataset.activeScheme);
        b.classList.add(active ? b.dataset.activeScheme : b.dataset.scheme);
      });

      root.querySelectorAll('[data-cb-panel]').forEach((p) => {
        p.hidden = p !== panel;
      });

      document.dispatchEvent(new CustomEvent('cb:category-changed', { detail: { key } }));
      if (scroll) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return panel;
    };

    const openDrawer = (root, tierId) => {
      const dialog = root.querySelector(`[data-cb-card][data-cb-tier="${tierId}"] [data-cb-drawer]`);
      if (!dialog || dialog.open) return;
      dialog.showModal();
      lockScroll(true);
    };

    const init = (root) => {
      if (root.dataset.cbReady) return;
      root.dataset.cbReady = 'true';

      root.querySelectorAll('[data-cb-card]').forEach((card) => {
        const first = card.querySelector('[data-cb-variant]');
        if (first) applyVariant(root, card, first);
      });

      root.querySelectorAll('[data-cb-drawer]').forEach((dialog) => {
        dialog.addEventListener('close', () => lockScroll(false));
      });

      root.addEventListener('click', (event) => {
        const target = event.target;

        const category = target.closest('[data-cb-cat]');
        if (category) return setCategory(root, category.dataset.cbKey);

        const scrollLink = target.closest('[data-cb-scroll]');
        if (scrollLink) {
          const destination = document.getElementById(scrollLink.getAttribute('href').slice(1));
          if (destination) {
            event.preventDefault();
            destination.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
          return;
        }

        const opener = target.closest('[data-cb-open]');
        if (opener && target.closest('button, a')) return openDrawer(root, opener.dataset.cbOpen);

        const closer = target.closest('[data-cb-close]');
        if (closer) return closer.closest('dialog').close();

        if (target.matches('[data-cb-drawer]')) return target.close();

        const galleryBtn = target.closest('[data-cb-gallery]');
        if (galleryBtn) {
          const track = galleryBtn.closest('.cb-gallery').querySelector('[data-cb-track]');
          track.scrollBy({ left: Number(galleryBtn.dataset.cbGallery) * track.clientWidth * 0.8, behavior: 'smooth' });
          return;
        }

        const qtyButton = target.closest('[data-cb-qty]');
        if (qtyButton) {
          const input = qtyButton.parentElement.querySelector('input');
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(qtyButton.dataset.cbQty));
          return;
        }

        const card = target.closest('[data-cb-card]');
        if (!card) return;

        const materialBtn = target.closest('[data-cb-material-btn]');
        if (materialBtn) return selectMaterial(root, card, materialBtn.dataset.cbMaterialBtn);

        const colourBtn = target.closest('[data-cb-colour-btn]');
        if (colourBtn) return selectColour(root, card, colourBtn.dataset.cbColourBtn);
      });

      // Events from the "Help me choose" quiz section
      const activateCard = (card) => {
        const panel = card.closest('[data-cb-panel]');
        setCategory(root, panel.dataset.cbKey);
        return panel;
      };

      // Events from the "Bundle guide banner" section
      document.addEventListener('cb:category', (event) => {
        setCategory(root, event.detail.key, event.detail.scroll);
      });

      document.addEventListener('cb:open', (event) => {
        const card = root.querySelector(`[data-cb-card][data-cb-handle="${CSS.escape(event.detail.handle)}"]`);
        if (!card) return;
        activateCard(card);
        openDrawer(root, card.dataset.cbTier);
      });

      document.addEventListener('cb:compare', (event) => {
        const card = root.querySelector(`[data-cb-card][data-cb-handle="${CSS.escape(event.detail.handle)}"]`);
        if (!card) return;
        const panel = activateCard(card);
        (panel.querySelector('.cb-grid') || panel).scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      // Close the drawer once the bag is submitted, so Stretch's cart drawer is visible
      root.addEventListener('submit', (event) => {
        const dialog = event.target.closest('[data-cb-drawer]');
        if (dialog) requestAnimationFrame(() => dialog.close());
      });
    };

    document.querySelectorAll('[data-cb-root]').forEach(init);

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-cb-root]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
